"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <h1 className="text-4xl font-[family-name:var(--font-display)] mb-4">
          Something went wrong
        </h1>
        <p className="text-black/40 mb-8">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={reset}
          className="px-6 py-3 bg-violet-800 text-white rounded-full text-sm font-medium hover:bg-violet-700 transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
